/**
 * Reusable Site Contact Field Component
 * Can be used in both Order Intake and Order Management with consistent styling
 */

import {Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ContactNameField, ContactPhoneField} from '../Contact/ContactFormFields'

/**
 * Reusable Site Contact Field component with name and phone number fields
 */
export const SiteContactField: React.FC = () => {
  const {t} = useTranslation()

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
      <ContactNameField
        fieldName="siteContact.name"
        label={t('orderIntake.rmc.steps.shared.siteContactNameLabel', 'Site contact name')}
        required={false}
        bordered
        testId="site-contact-name-input"
      />
      <ContactPhoneField
        fieldName="siteContact.phoneNumber"
        label={t('orderIntake.rmc.steps.shared.siteContactPhoneLabel', 'Site contact phone')}
        required={false}
        bordered
        testId="site-contact-phone-input"
      />
    </Box>
  )
}
